<template>
  <div class="page-builder">
    <div class="pb-sidebar">
      <b-container style="height: 50px;">
        <div id="pb-actions">
          <button v-if="mode == 'workflows'" @click="saveButton()" class="btn btn-secondary"><font-awesome-icon icon="save"/></button>
          <div class="btn-group mr-2">
            <button @click="toggleGrid" class="btn btn-secondary"><font-awesome-icon :icon="['fas', 'border-none']" /></button>
            <button @click="showPreview" class="btn btn-secondary"><font-awesome-icon icon="eye"/></button>
          </div>
          <div class="btn-group">
            <button @click="runUndo" class="btn btn-secondary"><font-awesome-icon :icon="['fas', 'undo']" /></button>
            <button @click="runRedo" class="btn btn-secondary"><font-awesome-icon :icon="['fas', 'redo']" /></button>
          </div>
          <button v-if="mode == 'workflows'" @click="closeView" class="btn btn-secondary"><font-awesome-icon :icon="['fas', 'window-close']" /></button>
        </div>
      </b-container>
      <b-container class="m-2">
        <label>Device</label>
        <div class="form-group">
          <select v-model="currentDevice" class="form-control" @change="updateDevice">
            <option v-for="d in devicesConfig.devices" :key="d.id">{{ d.name }}</option>
          </select>
        </div>
      </b-container>
      <b-tabs>
        <b-tab>
          <template #title>
            <font-awesome-icon icon="edit" />
          </template>
          <div style="max-height:550px;overflow: auto;">
            <div id="pb-blocks">
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon icon="layer-group" />
          </template>
          <div style="max-height:550px;overflow: auto;">
            <div id="pb-layers">
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon icon="cog" />
          </template>
          <div style="max-height:550px;overflow: auto;">
            <div id="pb-traits">
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon icon="paint-brush" />
          </template>
          <div style="max-height:550px;overflow: auto;">
            <div id="pb-selectors">
            </div>
            <div id="pb-styles">
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div id="dndEditor" class="pb-content">
    </div>
  </div>
</template>

<script>
import cmsdocs from '@/modules/cmsdocs.js';
import { pbDevices, BaseBuilder } from './basebuilder.js';
import layoutPlugin from './layoutwidgets.js';
import workflowPlugin from './workflowforms.js';
import connectorPlugin from './connectorwidgets.js';
import customwidgets from './customwidgets.js';
import mailPlugin from './mailblocks.js';
import ihandPlugin from './ihandwidgets.js';
import grapesjs from 'grapesjs';
import juice from 'juice';
//import blocksPlugin from 'grapesjs-blocks-basic';
import customCodePlugin from 'grapesjs-custom-code';

export default {
  name: 'PageBuilder',
  props:["mode","cmsDoc"],
  async mounted() {
    this.$emit('ready');
  },

  methods: {

    showPreview() {
      if (!this.preview) {
        this.editor.runCommand('core:preview');
      } else {
        this.editor.stopCommand('core:preview');
      }
      this.preview = !this.preview;
    },

    runUndo() {
      this.editor.runCommand('core:undo');
    },

    runRedo() {
      this.editor.runCommand('core:redo');
    },

    toggleGrid() {
      if (this.outlines) {
        this.editor.stopCommand('core:component-outline');
      } else {
        this.editor.runCommand('core:component-outline');
      }
      this.outlines = !this.outlines;
    },

    closeView() {
      this.$emit('close');
    },

    //
    // update device view
    //
    updateDevice() {
      if (this.currentDevice !== '') {
        this.editor.Devices.select(this.currentDevice);
      }
    },

    //
    // init editor
    //
    async createEditor(area) {
      this.tree = area;
      // select plugins for given mode
      var pluginList   = [layoutPlugin];
      var styleList    = [];
      var jscriptsList = [];
      var bb = new BaseBuilder();
      var blist = [];
      var slist = false;
      var jlist = false;
      var i;

      console.log('CREATE mode:',this.mode);

      if (this.mode == 'workflows') {
        console.log('add workflow plugin');
        pluginList.push(workflowPlugin);
        slist = await cmsdocs.listResources('firm-ui','ui-styles');
        jlist = await cmsdocs.listResources('firm-ui','ui-js');
        blist = await cmsdocs.listResources('firm-ui','ui-images');
        if (blist) {
          for (i in blist) {
            this.assets.push('/myfirm/ui-images/' + encodeURIComponent(blist[i]));
          }
        }
      } else if (this.mode == 'ihand-ui') {
        console.log('LOAD IHAND MODE');
        this.urlPrefix = '/global';
        slist = await cmsdocs.listResources('ihand-ui','ui-styles');
        jlist = await cmsdocs.listResources('ihand-ui','ui-js');
        blist = await cmsdocs.listResources('ihand-ui','ui-images');
        if (blist) {
          for (i in blist) {
            this.assets.push('/global/ui-images/' + encodeURIComponent(blist[i]));
          }
        }
        pluginList.push(ihandPlugin);
      } else if (this.mode == 'jsonmail') {
        slist = [];
        jlist = [];
        blist = [];
        pluginList.push(mailPlugin);
      } else {
        // default firm ui injections
        slist = await cmsdocs.listResources('firm-ui','ui-styles');
        jlist = await cmsdocs.listResources('firm-ui','ui-js');
        blist = await cmsdocs.listResources('firm-ui','ui-images');
        if (blist) {
          for (i in blist) {
            this.assets.push('/myfirm/ui-images/' + encodeURIComponent(blist[i]));
          }
        }
      }

      // sort script list for dependencie problems
      slist.sort();
      jlist.sort();
      console.log('scriptlist',jlist);

      // append / inject scripts and styles for area
      for (var s in slist) {
        styleList.push(this.urlPrefix + '/ui-styles/' + encodeURIComponent(slist[s]));
      }
      for (var j in jlist) {
        jscriptsList.push(this.urlPrefix + '/ui-js/' + encodeURIComponent(jlist[j]));
      }

      // add default plugins
      //pluginList.push(blocksPlugin);

      if (this.mode == 'ihand-ui') {
        console.log('ihand mode');
      } else if (this.mode == 'jsonmail') {
        console.log('mail mode');
      } else {
        var rlist = await fetch('/trendshop.proxy.web/rest/reports/?start=0&count=500').then(resp => resp.json());
        console.log('reports loaded',rlist);
        pluginList.push(grapesjs.usePlugin(connectorPlugin,{ reports: rlist }));
      }

      if (!(this.mode == 'jsonmail')) {
        pluginList.push(customCodePlugin);
      }

      // add custom widgets plugin
      var customs = await cmsdocs.listhtmlcomponents(this.tree);
      console.log('customs html',customs);
      pluginList.push(grapesjs.usePlugin(customwidgets,customs));

      console.log('Assets: ',this.assets);

      this.editor = grapesjs.init({
        height: '100%',
        showOffsets: true,
        noticeOnUnload: false,
        storageManager: false,
        container: '#dndEditor',
        fromElement: true,
        plugins: pluginList,
        deviceManager: this.devicesConfig,
        canvas: {
          styles: styleList,
          scripts: jscriptsList
        },
        blockManager: {
          appendTo: '#pb-blocks'
        },
        layerManager: {
          appendTo: '#pb-layers'
        },
        styleManager: {
          appendTo: '#pb-styles'
        },
        traitManager: {
          appendTo: '#pb-traits'
        },
        selectorManager: {
          appendTo: '#pb-selectors',
          componentFirst: true,
        },
        assetManager: {
          upload: '/trendshop.proxy.web/rest/cms/assets/images/' + this.mode,
          assets: this.assets
        },
        panels: {
          defaults: {}
        }
      });

      bb.addBlocks(this.editor);
      bb.addComponents(this.editor);


      if (this.mode == 'workflows')
        this.addToolBar();

      // add html editor button
      this.editor.Panels.addButton('options',
          [
              {
                  id: 'edit',
                  className: 'fa fa-edit',
                  command: 'html-edit',
                  attributes: {
                      title: 'Edit'
                  }
              }
          ]
      );

      const categories = this.editor.BlockManager.getCategories();
      categories.each(category => {
        category.set('open', false).on('change:open', opened => {
          opened.get('open') && categories.each(category => {
            category !== opened && category.set('open', false)
          })
        })
      });

      if (this.cmsDoc && this.cmsDoc > 0) {
        this.loadDocument();
      }

    },

    //
    // load an cms document
    //
    async loadDocument() {
      if (this.cmsDoc == 0) return; // no new doc to load
      var data = await cmsdocs.loadDocument(this.cmsDoc);
      this.setContent(data);
    },

    getSelected() {
        return this.editor.getSelected();
    },

    //
    // add basic toolbar buttons
    //
    addToolBar() {
      this.editor.Panels.addButton('options',[
        {
          id: 'save',
          className: 'fa fa-floppy-o icon-blank',
          attributes: { title: 'Speichern' },
          command: this.saveButton.bind(this)
        },
        {
          id: 'close',
          className: 'fa fa-close icon-blank',
          attributes: { title: 'Schließen' },
          command: this.closeButton.bind(this)
        }
      ]);
    },
    //
    // emit the save event with project data
    //
    saveButton() {
      var data = this.editor.getProjectData();
      this.$emit('save',{ "content": data, "document": this.doc });
    },

    //
    // update content from parent
    //
    setContent(data) {
      var project = JSON.parse(data.documentData);
      this.editor.loadProjectData(project);
      this.editor.AssetManager.add(this.assets);
    },

    //
    // abfrage der aktuellen dokumenten daten
    //
    getContent() {
      return this.editor.getProjectData();
    },

    // access styles
    getCss() {
      return this.editor.getCss();
    },

    getJs() {
      return this.editor.getJs();
    },

    getHtml() {
      return this.editor.getHtml();
    },

    getInlineCSSHTML() {
      var htmlString = '<style>' + this.editor.getCss() + '</style>' + this.editor.getHtml();
      console.log('base css inline start',htmlString);
      return juice(htmlString, {});
    },

    //
    // close the editor signal
    //
    closeButton() {
      this.$emit('close');
    },
  },
  beforeDestroy: function() {
    if (this.editor.destroy) {
      this.editor.destroy();
    }
  },
  data() {
    return {
      assets: [],
      init: false,
      editor: false,
      outlines: false,
      preview: false,
      doc: {  },
      urlPrefix: '/myfirm',
      currentDevice: '',
      devicesConfig: {
        default: '',
        devices: pbDevices,
      }
    }
  },
}
</script>

<style>
.page-builder {
  width: 100%;
  height: 100%;
  display: flex;
}
.pb-sidebar {
  flex: 15%;
  float:left;
}

.pb-content {
    float:right;
    flex: 84%;
}

.gjs-one-bg {
  background-color: #fff !important
}

.gjs-two-color {
  color: #9ca8bb !important;
}

.gjs-three-bg {
  background-color: #1e8fe1;
  color: #fff;
}

.gjs-four-color, .gjs-four-color-h:hover {
  color: #1e8fe1 !important
}

.gjs-pn-btn {
  border: 1px solid rgba(0,0,0,0.4);
}

.gjs-cv-canvas {
  width: 100%;
  height: 100%;
  top: 0;
}

</style>
